export default __webpack_public_path__ + "static/media/Sample.d433518e.csv";